var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 900 600",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#ee1c25}.st1{fill:#0b4ea2}.st2{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0 0h900v600H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0 0h900v400H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0 0h900v200H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_",
    className: "st2",
    d: "M393.479 141H146.358l-.847 8.059c-.184 1.752-4.511 43.971-4.511 136.69 0 43.563 14.726 81.996 43.77 114.23 20.349 22.585 46.923 41.599 81.242 58.129l3.905 1.881 3.906-1.881c34.32-16.53 60.896-35.544 81.246-58.129 29.044-32.234 43.771-70.667 43.771-114.23 0-92.718-4.328-134.938-4.512-136.69l-.849-8.059z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M269.917 450C220.577 426.234 150 379.062 150 285.749S154.461 150 154.461 150H385.376s4.463 42.437 4.463 135.749c0 93.313-70.578 140.485-119.922 164.251z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M280.484 261.284c13.36.216 39.425.739 62.635-7.027 0 0-.613 8.306-.613 17.98 0 9.677.613 17.982.613 17.982-21.289-7.125-47.58-7.273-62.635-7.082v51.539H259.38v-51.539c-15.055-.191-41.345-.043-62.635 7.082 0 0 .613-8.305.613-17.982 0-9.675-.613-17.98-.613-17.98 23.21 7.766 49.275 7.243 62.635 7.027v-32.368c-12.177-.108-29.723.473-49.563 7.113 0 0 .613-8.305.613-17.982 0-9.676-.613-17.981-.613-17.981 19.81 6.628 37.336 7.219 49.509 7.114-.626-20.498-6.597-46.332-6.597-46.332s12.289.959 17.202.959c4.918 0 17.203-.959 17.203-.959s-5.969 25.835-6.596 46.33c12.174.106 29.699-.485 49.509-7.114 0 0-.613 8.305-.613 17.981 0 9.677.613 17.982.613 17.982-19.839-6.639-37.386-7.221-49.563-7.113V261.284z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.904 329.094c-24.852 0-38.163 34.469-38.163 34.469s-7.385-16.344-27.661-16.344c-13.719 0-23.829 12.201-30.256 23.5 24.959 39.705 64.78 64.207 96.079 79.281 31.305-15.075 71.152-39.571 96.112-79.281-6.427-11.299-16.537-23.5-30.256-23.5-20.277 0-27.693 16.344-27.693 16.344s-13.308-34.469-38.162-34.469z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSk);
export default __webpack_public_path__ + "static/media/sk.7cfdb2146d43435d8bee2227820d1bc9.svg";
export { ForwardRef as ReactComponent };